import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import TermsModal from '../components/TermsModal';
import { offerFootnote } from '../offer';
import foodImage from '../assets/img/whole-big-mac.png';
import mLogoRed from '../assets/img/m-logo-red.svg';
import TeamLogo from '../components/TeamLogo';
import myMaccasLogo from '../assets/img/my-maccas-logo.svg';
import appStoreBadge from '../assets/img/app-store-badge.svg';
import googlePlayBadge from '../assets/img/google-play-badge.svg';
import tapMore from '../assets/img/tap-more.png';
import gotAVoucher from '../assets/img/got-a-voucher.png';
import enterCode from '../assets/img/enter-code-and-redeem.png';
import { APP_STORE_SMART_LINK } from '../constants';

const Wrapper = styled.div`
  margin: -58px -16px 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  background: #db0007;
`;

const RedSection = styled.div`
  background: #db0007;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  padding: 8px 10px 10px;
  z-index: 2;
  flex-shrink: 0;
`;

const LogoImg = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

const Heading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 32px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;
  margin: 32px 16px 0;
`;

const BurgerImage = styled.img`
  width: 295px;
  display: block;
  margin: -24px auto -26px;
  position: relative;
  z-index: 2;
`;

const WhiteCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  margin: -40px 16px 0;
  padding: 55px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
`;

const MyMaccasLogoImg = styled.img`
  width: 72px;
  height: 35px;
  margin-bottom: 16px;
`;

const CodeBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 2px solid #e3e3e3;
  border-radius: 4px;
  padding: 8px 11px 8px 12px;
  box-sizing: border-box;
  min-height: 50px;
  margin-bottom: 4px;
`;

const CodeInputWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const CodeLabel = styled.span`
  font-family: 'Speedee Regular';
  font-size: 10px;
  line-height: 1.4;
  color: rgba(45, 45, 45, 0.6);
`;

const CodeText = styled.span`
  font-family: 'Speedee Regular';
  font-size: 14px;
  line-height: 1.4;
  color: #2d2d2d;
`;

const CopyBtn = styled.button`
  background: #ffffff;
  border: 1px solid #2d2d2d;
  border-radius: 4px;
  padding: 8px;
  font-family: 'Speedee Bold';
  font-size: 12px;
  color: #000000;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
`;

const RedeemText = styled.p`
  font-family: 'Speedee Bold';
  font-size: 16px;
  line-height: normal;
  color: #2d2d2d;
  text-align: center;
  margin: 8px 0 16px;
`;

const ClaimButton = styled.button`
  width: 100%;
  background: #ffbc0d;
  border: none;
  border-radius: 8px;
  padding: 18px 32px;
  font-family: 'Speedee Bold';
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  color: #2d2d2d;
  text-align: center;
  cursor: pointer;
  line-height: 1;
  min-width: 120px;
`;

const HelpLink = styled.a`
  display: block;
  font-family: 'Speedee Regular';
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  color: #2d2d2d;
  opacity: 0.7;
  margin-top: 16px;
  cursor: pointer;
  text-decoration: underline;
`;

const RedFooter = styled.div`
  background: #db0007;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const FooterHeading = styled.p`
  font-family: 'Speedee Bold';
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin: 0 0 4px;
`;

const FooterText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin: 0 0 16px;
  max-width: 266px;
`;

const StoreBadges = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const BadgeImg = styled.img`
  height: 42px;
  width: auto;
`;

const Disclaimer = styled.p`
  font-family: 'Speedee Regular';
  font-size: 12px;
  color: #ffffff;
  opacity: 0.7;
  line-height: 1.4;
  margin: 0;
  text-align: center;

  a {
    color: #ffffff;
    text-decoration: underline;
  }
`;

/* Modal styles */
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const ModalWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 353px;
`;

const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 10px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  padding: 24px 0;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.55);
`;

const ModalClose = styled.button`
  position: absolute;
  top: -17px;
  right: -4px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1.5px solid #2d2d2d;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 101;
  padding: 0;
`;

const ModalTitle = styled.h2`
  font-family: 'Speedee Bold';
  font-size: 32px;
  color: #2d2d2d;
  text-align: center;
  margin: 0 0 24px;
  line-height: 1.1;
  padding: 0 24px;
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 24px;
  margin-bottom: 24px;
`;

const StepRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StepImage = styled.img`
  width: 150px;
  height: 150px;
  object-fit: contain;
  flex-shrink: 0;
`;

const StepText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 20px;
  color: #292929;
  line-height: normal;
  margin: 0;
  width: 140px;

  strong {
    font-family: 'Speedee Bold';
  }
`;

const ModalButton = styled.button`
  width: calc(100% - 48px);
  margin: 0 24px;
  background: #ffbc0d;
  border: none;
  border-radius: 8px;
  padding: 18px 32px;
  font-family: 'Speedee Bold';
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  color: #2d2d2d;
  text-align: center;
  cursor: pointer;
  line-height: 1;
  height: 52px;
  box-sizing: border-box;
`;

function ClaimSuccess({ prizeCode, setPage, offer }) {
  const [hasCopied, setHasCopied] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const copyCode = useCallback(() => {
    navigator.clipboard.writeText(prizeCode);
    setHasCopied(true);
    setTimeout(() => setHasCopied(false), 2000);
  }, [prizeCode]);

  const handleRedeem = () => {
    window.gtag('event', 'mm-code-btn-copyredeem');
    copyCode();
    window.location.href = `https://mcdonaldsau.smart.link/xwnt113su?code=${encodeURIComponent(prizeCode)}`;
  };

  const showTermsModal = () => {
    window.gtag('event', 'mm-code-btn-tcs');
    setShowTerms(true);
  };

  const hideTermsModal = () => {
    setShowTerms(false);
  };

  const showLinkNotWorking = () => {
    window.gtag('event', 'mm-code-btn-help');
    setShowHelpModal(true);
  };

  const hideLinkNotWorking = (suffix = '') => {
    window.gtag('event', `mm-help${suffix}`);
    setShowHelpModal(false);
  };

  // useEffect(() => {
  //   if (showHelpModal) trackPageView('mm-help');
  // }, [showHelpModal]);

  return (
    <Wrapper>
      <RedSection>
        <LogoContainer>
          <LogoImg src={mLogoRed} alt="McDonald's" />
          <TeamLogo />
        </LogoContainer>

        <Heading>
          You've won a
          <br />
          Big Mac®!
        </Heading>

        <BurgerImage src={foodImage} alt="Big Mac" />
      </RedSection>

      <WhiteCard>
        <MyMaccasLogoImg src={myMaccasLogo} alt="MyMacca's" />

        <CodeBox>
          <CodeInputWrap>
            <CodeLabel>Your Claim Code</CodeLabel>
            <CodeText>{prizeCode || 'ABCD1234567890YZ'}</CodeText>
          </CodeInputWrap>
          <CopyBtn
            onClick={() => {
              window.gtag('event', 'mm-code-btn-copy');
              copyCode();
            }}>
            {hasCopied ? 'Copied' : 'Copy'}
          </CopyBtn>
        </CodeBox>

        <RedeemText>
          Click 'Redeem' to claim your reward
          <br />
          in the MyMacca's® app*
        </RedeemText>

        <ClaimButton onClick={handleRedeem}>COPY CODE & REDEEM</ClaimButton>

        <HelpLink onClick={showLinkNotWorking}>Link Not Working?</HelpLink>
      </WhiteCard>

      <RedFooter>
        <FooterHeading>Don't have MyMacca's® yet?</FooterHeading>
        <FooterText>Download the app and come back to redeem your reward.</FooterText>
        <StoreBadges>
          <a href={APP_STORE_SMART_LINK} onClick={() => window.gtag('event', 'mm-code-btn-applestore')} target="_blank" rel="noreferrer">
            <BadgeImg src={appStoreBadge} alt="Download on the App Store" />
          </a>
          <a href={APP_STORE_SMART_LINK} onClick={() => window.gtag('event', 'mm-code-btn-googlestore')} target="_blank" rel="noreferrer">
            <BadgeImg src={googlePlayBadge} alt="Get it on Google Play" />
          </a>
        </StoreBadges>
        <Disclaimer>
          {offerFootnote(offer)}
          <br />
          <a onClick={() => showTermsModal()} style={{ cursor: 'pointer' }}>
            Terms & Conditions apply
          </a>
        </Disclaimer>
      </RedFooter>

      {showTerms && <TermsModal offer={offer} onClose={() => hideTermsModal()} />}

      {showHelpModal && (
        <ModalOverlay onClick={() => hideLinkNotWorking('-tap-outside')}>
          <ModalWrapper onClick={(e) => e.stopPropagation()}>
            <ModalClose onClick={() => hideLinkNotWorking('-btn-close')}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5L15 15M15 5L5 15" stroke="#2D2D2D" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </ModalClose>
            <ModalContent>
              <ModalTitle>Link Not Working?</ModalTitle>

              <StepsContainer>
                <StepRow>
                  <StepImage src={tapMore} alt="Open app" />
                  <StepText>
                    Open the <strong>MyMacca's® App</strong> and tap <strong>More</strong>
                  </StepText>
                </StepRow>

                <StepRow style={{ flexDirection: 'row-reverse' }}>
                  <StepImage src={gotAVoucher} alt="Got a voucher" />
                  <StepText>
                    Tap on '<strong>Got a Voucher?</strong>'
                  </StepText>
                </StepRow>

                <StepRow>
                  <StepImage src={enterCode} alt="Enter code" />
                  <StepText>
                    Enter your <strong>16 Code</strong> and <strong>Redeem</strong>
                  </StepText>
                </StepRow>
              </StepsContainer>

              <ModalButton onClick={() => hideLinkNotWorking('-btn-okay')}>OKAY, GOT IT!</ModalButton>
            </ModalContent>
          </ModalWrapper>
        </ModalOverlay>
      )}
    </Wrapper>
  );
}

export default ClaimSuccess;
